import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import homeIcon from 'assets/components/main_topbar/home.svg'
import HeaderLogo from 'assets/components/header/header-logo.svg'
import MainTopbarTooltip from 'components/topbar/main/tooltip/tooltip'
import { localize } from 'helpers/translator'

import styles from './main_topbar.scss'

class MainTopbar extends PureComponent {
	constructor(props) {
		super(props)

		this.state = {
			hoverHomeIcon: false,
			hoverLogoIcon: false,
		}
	}

	componentDidMount() {
		this.props.initialize()
	}

	handleHomeIconOnMouseEnter = () => {
		this.setState({hoverHomeIcon: true})
	}

	handleHomeIconOnMouseLeave = () => {
		this.setState({hoverHomeIcon: false})
	}

	handleLogoIconOnMouseEnter = () => {
		this.setState({hoverLogoIcon: true})
	}

	handleLogoIconOnMouseLeave = () => {
		this.setState({hoverLogoIcon: false})
	}

	render() {
		const shouldShowTooltip = this.props.shouldShowTooltips
		let myLibraryIcon
		if (this.props.shouldUpdateNavTopbar) {
			myLibraryIcon = HeaderLogo
		} else {
			myLibraryIcon = homeIcon
		}

		return (
			<div styleName={classNames({wrapper: true, 'wrapper--slim': this.props.shouldUpdateNavTopbar})}>
				<div styleName='left-nav'>
					<div styleName={classNames({
						'right-nav-item': true,
						'right-nav-item--separator': !this.props.shouldUpdateNavTopbar,
					})}>
						<a
							styleName='right-nav-item-link'
							onClick={this.props.handleHomeSelection}
							onMouseEnter={this.handleHomeIconOnMouseEnter}
							onMouseLeave={this.handleHomeIconOnMouseLeave}
						>
							<img styleName={classNames({
								'right-nav-item-link-image': !this.props.shouldUpdateNavTopbar,
								'right-nav-item-link-logo': this.props.shouldUpdateNavTopbar,
							})} src={myLibraryIcon} alt='Home'/>
						</a>
						{ shouldShowTooltip && this.state.hoverHomeIcon &&
							<MainTopbarTooltip
								title={localize('topbar_home_tooltip_2')}
							/>
						}
					</div>
					{!this.props.shouldUpdateNavTopbar &&
						<div styleName='left-nav-item'>
							<a
								styleName='left-nav-link'
								onClick={this.props.handleLogoSelection}
								onMouseEnter={this.handleLogoIconOnMouseEnter}
								onMouseLeave={this.handleLogoIconOnMouseLeave}
							>
								<img styleName='left-nav-logo' src={HeaderLogo} alt='Logo'/>
							</a>
							{ shouldShowTooltip && this.state.hoverLogoIcon &&
								<MainTopbarTooltip
									title={localize('topbar_logo_tooltip')}
									arrow='top-left'
								/>
							}
						</div>
					}
				</div>
				<div styleName='right-nav'>
					{ this.props.add }
					{ this.props.quickLaunch }
					{ this.props.cart }
					{ this.props.navigationMenu }
				</div>
			</div>
		)
	}
}

MainTopbar.propTypes = {
	initialize: PropTypes.func,
	handleLogoSelection: PropTypes.func,
	handleHomeSelection: PropTypes.func,
	shouldShowTooltips: PropTypes.bool,
	add: PropTypes.element,
	quickLaunch: PropTypes.element,
	avatar: PropTypes.element,
	cart: PropTypes.element,
	navigationMenu: PropTypes.element,
	shouldUpdateNavTopbar: PropTypes.bool,
}

MainTopbar.defaultProps = {
	initialize: () => {},
	handleLogoSelection: () => {},
	handleHomeSelection: () => {},
	shouldShowTooltips: false,
	add: null,
	quickLaunch: null,
	avatar: null,
	cart: null,
	navigationMenu: null,
	shouldUpdateNavTopbar: false,
}

export default (CSSModules(MainTopbar, styles, {allowMultiple: true}))

export { MainTopbar }
